import { render, staticRenderFns } from "./index.vue?vue&type=template&id=10fcbb76&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fcbb76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\chenwllCode\\cunxian\\web-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10fcbb76')) {
      api.createRecord('10fcbb76', component.options)
    } else {
      api.reload('10fcbb76', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=10fcbb76&scoped=true", function () {
      api.rerender('10fcbb76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/rightBtn/index.vue"
export default component.exports